import { ModalContext } from 'app/app';
import axios from 'axios';
import { ViewContext } from 'components/lib';
import { useState } from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import { Fragment } from 'react';
import { endorsementIssues } from 'views/endorsementViewV2/endorsementIssues';

export default function AddEndorsementIssueModal() {
  const { modal, setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const [endorsementData, setEndorsementData] = useState(null);
  const [selectedIssues, setSelectedIssues] = useState([]);

  async function fetchEndorsementData() {
    if (!modal.data || !modal.data.endorsementId) return;

    try {
      const res = await axios.get(`/api/endorsement/${modal.data.endorsementId}`);
      const endorsementResponseData = res.data.data;
      setEndorsementData(endorsementResponseData);
      if (endorsementResponseData && endorsementResponseData.changes) {
        setSelectedIssues(endorsementResponseData.changes);
      }
    } catch (err) {
      console.error(err);
      context.notification.show(
        'Something went wrong!',
        'error',
        true,
        'toast',
        'x-circle'
      );
      setModal('');
    }
  }

  useEffect(() => {
    if (modal.name === 'add_endorsement_issue_modal') {
      fetchEndorsementData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal.name]);

  const handleIssueChange = (issue) => {
    setSelectedIssues((prevSelectedIssues) => {
      const issueObject = { type: 'other', value: issue };
      if (prevSelectedIssues.some((i) => i.value === issue)) {
        return prevSelectedIssues.filter((i) => i.value !== issue);
      } else {
        return [...prevSelectedIssues, issueObject];
      }
    });
  };

  const handleSaveClick = async () => {
    if (selectedIssues.length === 0) {
      context.notification.show(
        'Please select at least one issue before continuing.',
        'error',
        true,
        'toast',
        'x-circle'
      );
      return;
    } else {
      try {
        const updatedIssues = selectedIssues.map((issue) => {
          const existingIssue = endorsementData.changes.find(
            (i) => i.value === issue.value
          );
          return existingIssue
            ? {
              ...existingIssue,
              solved: issue.solved || existingIssue.solved,
            }
            : issue;
        });

        const response = await axios.put(`/api/endorsement/${modal.data.endorsementId}`, {
          changes: updatedIssues,
        });

        if (response.status !== 200) {
          throw new Error('Failed to update endorsement issue');
        }

        context.notification.show(
          'Issues added successfully!',
          'success',
          true,
          'toast',
          'check-circle'
        );

        setModal('');

        if (modal.data.onUpdate && typeof modal.data.onUpdate === 'function') {
          modal.data.onUpdate();
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message ||
          'There was a problem when updating the issue.';

        context.notification.show(
          errorMessage,
          'error',
          true,
          'toast',
          'x-circle'
        );
      }
    }
  };

  return (
    <Fragment>
      {modal.name === 'add_endorsement_issue_modal' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[102] flex items-center justify-center">
          <div className="w-full max-w-[600px] bg-white flex items-center justify-center rounded-[12px]">
            <div className="w-[93%] mt-[20px] mb-[8px]">
              <div
                className="mb-6 1w-full mx-auto bg-white max-w-screen-xl"
                id="14"
              >
                <div className="p-4 pl-6 mt-4 pt-0">
                  Add new issues that need to be addressed:
                </div>

                <div className="flex-col border rounded p-4 pt-0 border-slate-300 mx-6">
                  {endorsementIssues.map((issue, index) => (
                    <div
                      key={index}
                      className="flex justify-between py-2 border-b border-slate-300"
                    >
                      <div>{issue.value}</div>
                      <input
                        type="checkbox"
                        checked={selectedIssues.some(
                          (i) => i.value === issue.value
                        )}
                        onChange={() =>
                          handleIssueChange(issue.value)
                        }
                      />
                    </div>
                  ))}
                </div>

                <div className="p-4 mt-4 pt-0">
                  <div className="w-full flex items-center justify-end">
                    <button
                      className="h-12 px-4 bg-white border border-gray-400 font-semibold rounded-md cursor-pointer"
                      onClick={() => {
                        setModal('');
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="h-12 ml-2 px-4 bg-[#d32425] font-semibold rounded-md cursor-pointer text-white disabled:bg-gray-200 disabled:cursor-not-allowed"
                      onClick={handleSaveClick}
                      disabled={
                        modal.data && modal.data.endorsementStatus === 'complete'
                      }
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
